<template>
  <v-btn
    dark
    @click="trigger"
    :loading="loading"
    color="white green--text"
    class="register"
  >{{label}}</v-btn>
</template>

<script>
export default {
  props: ['label', 'loading'],
  data: () => ({}),
  methods: {
    trigger() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/index.scss";
.register {
  margin: 0;
  background: white;
  color: green;
  border: 2px solid green;
  border-radius: 50px;
  width: 100%;
  height: 50px;
  font-weight: bold;

  cursor: pointer;
  &:hover {
  }
}
</style>
